module.exports = __webpack_public_path__ + "img/registerBackImg.9d0566f1.jpg";